import React, { useEffect } from 'react';
import appConfig from 'app-config';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { AskForemostService_Ext } from 'ml-services-common-react';
import metadata from './AskForemostPage.metadata.json5';

const URL_MAPPINGS = {
    'farmerssrm--somet1': {
        'scriptUrl': 'https://farmerssrm--somet1.sandbox.lightning.force.com/lightning/lightning.out.js',
        'searchUrl': 'https://farmerssrm--somet1.sandbox.lightning.force.com'
    },
    'farmerssrm--srmqa': {
        'scriptUrl': 'https://farmerssrm--srmqa.sandbox.lightning.force.com/lightning/lightning.out.js',
        'searchUrl': 'https://farmerssrm--srmqa.sandbox.lightning.force.com'
    },
    'farmerssrm': {
        'scriptUrl': 'https://farmerssrm.lightning.force.com/lightning/lightning.out.js',
        'searchUrl': 'https://farmerssrm.lightning.force.com'
    }
};
const EXPIRATION_TIME = 1800000;

function AskForemostPage() {
    const { authUserData, authHeader } = useAuthentication();
    const { MLUserTypes } = appConfig;

    // Remove Header and Footer HTML Elements from Page
    useEffect(() => {
        const headerElement = document.getElementById("pageHeader");
        const footerElement = document.getElementById("mainFooterPE");

        if (headerElement && footerElement) {
            headerElement.remove();
            footerElement.remove();
        }
    }, []);

    function getUserType() {
        let authUserType = null;
        if (authUserData) {
            switch(authUserData.userType) {
                case MLUserTypes.PCS:
                    authUserType = 'EA';
                    break;
                case MLUserTypes.IA:
                    authUserType = 'IA';
                    break;
                case MLUserTypes.MET_GA:
                    authUserType = 'IA';
                    break;
                default:
                    break;
            }
        }
        return authUserType;
    }

    function loadScripts(sessionID, scriptURL, searchURL) {
        const userType = getUserType();
        const script = document.createElement('script')

        script.src = scriptURL
        script.async = true;
        script.onload = () => {
            console.log('>>> LOADED LIGHTNING SCRIPT <<<');
            // eslint-disable-next-line no-undef
            $Lightning.use("c:SRM_KnowledgeApp",
                () => {
                    // eslint-disable-next-line no-undef
                    $Lightning.createComponent(
                        "c:knowledgeArticleSearchParentComp",
                        {
                            "inputParameters" : {brand: 'Foremost Signature', role: userType}
                        },
                        "datatable",
                        (cmp) => {
                            console.log("Lightning LWC Component is Loaded...", cmp);
                        }
                    );
                },
                searchURL,
                sessionID);
        };

        const sfEl = document.getElementById('datatable');

        if (sfEl && !sfEl.hasChildNodes()) {
            document.body.appendChild(script);
        }
    }

    function setSalesforceLocalStorage(response) {
        window.localStorage.setItem('salesforceAccessToken', response.accessToken);
        window.localStorage.setItem('salesforceInstanceUrl', response.instanceUrl);
        window.localStorage.setItem('salesforceAccessTokenExp', Date.now());
    }

    function removeSalesforceLocalStorage() {
        window.localStorage.removeItem('salesforceAccessToken');
        window.localStorage.removeItem('salesforceInstanceUrl');
        window.localStorage.removeItem('salesforceAccessTokenExp');
    }

    function getSearchScriptUrls (url) {
        const hostname = url.split(".")[0];
        const environment = hostname.split("//")[1];
        return URL_MAPPINGS[`${environment}`];
    }

    function retrieveAccessToken() {
        AskForemostService_Ext.getSalesforceAccessToken(authHeader).then((response) => {
            if (!_.isEmpty(response.instanceUrl)) {
                const scriptSearchUrls = getSearchScriptUrls(response.instanceUrl);
                if (scriptSearchUrls) {
                    setSalesforceLocalStorage(response);
                    loadScripts(response.accessToken, scriptSearchUrls.scriptUrl, scriptSearchUrls.searchUrl);
                }
            }
            else {
                console.log("Error: Unable to retrieve valid response from SRM server - please refresh page");
            }
        }) 
    }

    useEffect(() => {
        if (window.localStorage.getItem('salesforceAccessToken') && window.localStorage.getItem('salesforceInstanceUrl') && window.localStorage.getItem('salesforceAccessTokenExp')) {
            const currentDate = Date.now()
            if ((currentDate - window.localStorage.getItem('salesforceAccessTokenExp')) > EXPIRATION_TIME) {
                removeSalesforceLocalStorage()
                retrieveAccessToken();
            } else {
                const scriptSearchUrls = getSearchScriptUrls(window.localStorage.getItem('salesforceInstanceUrl'));
                loadScripts(window.localStorage.getItem('salesforceAccessToken'), scriptSearchUrls.scriptUrl, scriptSearchUrls.searchUrl);
            }
        } else {
            retrieveAccessToken();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <MetadataContent uiProps={metadata.pageContent} />
}

export default AskForemostPage;
